import { RenderBlock } from '@rst/render-blocks/src/types'
import { color, IconNameType } from '@rst/ui-ts'
import { useMemo } from 'react'

export const colorGradient = ({ theme }: any) => {
	const a = color('primary-08')({ theme })
	if (a.match(/gradient/g)) {
		return a
	}
	return `linear-gradient(90deg,
		${color('primary-08')({ theme })} 0%,
		${color('primary-08')({ theme })} 100% )`
}

const socialIcons = {
	facebook: 'rst-facebook',
	instagram: 'rst-instagram',
	ok: 'rst-odnoklassniki',
	vk: 'rst-vkontakte',
	youtube: 'rst-youtube',
	rst: 'rst-logo',
	telegram: 'rst-telegram',
	whatsapp: 'rst-whatsapp',
	twitter: 'rst-twitter',
	/* 	appstope: 'rst-bisness_case',
	playmarket: 'rst-bisness_case',
	appgallery: 'rst-bisness_case', */
}

export const useSocial: (
	social?: RenderBlock.InfoSocial
) => { type: IconNameType; value: string }[] = social => {
	return useMemo(() => {
		if (!social) return []
		return Object.entries(social)
			.map(([key, value]) => {
				return { type: socialIcons[key], value }
			})
			.filter(({ type, value }) => type && value)
	}, [social])
}
